import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { AlertService } from "app/modules/core/old/alert.service";
import { CeloFileUploader } from "@modules/shared/file-upload";

@Component({
  selector: "app-drop-zone",
  templateUrl: "./drop-zone.component.html",
  styleUrls: ["./drop-zone.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DropZoneComponent {
  @Input()
  formats: string[];

  @Input()
  type: string;

  @Input()
  uploader: CeloFileUploader;

  constructor(private alertService: AlertService) {}

  app() {
    const payload = [
      {
        type: "downloadMobileAppInfo",
        message: "Record and upload videos using the Celo mobile app!",
      },
    ];
    this.alertService.customDialog(
      "Celo mobile app ",
      "",
      "DONE",
      "",
      true,
      "vertical",
      payload
    );
  }
}
